import numbro from "numbro";

export function cropAddress(addr: string) {
    const meetAddress = addr.split(',');
    const divLoc = Math.ceil(meetAddress.length / 2);
    return divLoc > 1
        ? meetAddress[divLoc - 1] +
        (meetAddress[divLoc - 1] === meetAddress[meetAddress.length - 2]
            ? ''
            : ', ' + meetAddress[meetAddress.length - 2])
        : addr;
}

export default function currency(num: any) {
    const amount = typeof num === 'string' ? parseFloat(num) : num;
    return '$' + numbro(amount).format({ thousandSeparated: true });
}

export function firstCapital(word: string) {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();

}

enum KeyDic {
    'string' = 'string',
    'number' = 'number'
}
export type Dic = {
    [key in KeyDic]: any
}